import { PlusCircleIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';

export const AddIntegrationLink = () => {
  return (
    <Link
      to="/onboarding/setup"
      className="flex items-center justify-center gap-x-2 rounded-md border border-dashed border-sage-500 bg-sage-100 p-4 font-bold text-gray-700 outline-none focus-visible:ring-2 focus-visible:ring-rose-700 focus-visible:ring-offset-2"
    >
      Add integration
      <PlusCircleIcon className="size-6 shrink-0 text-sage-600" />
    </Link>
  );
};
